<template>
  <div>
    <NavBar />
    <!-- 申请结算页面 -->
    <div class="content-container">
      <div class="list-container">
        <div class="menu-title">
          查看详情
          <div style="float: right">
            <el-button
              type="primary"
              @click="paymentReported"
              v-if="showStatus == 1"
            >下载对账单</el-button>
            <el-button
              @click="back"
              style="margin-left: 10px"
            >返回</el-button>
          </div>
        </div>
        <el-card
          shadow="never"
          style="border: none"
        >
          <div
            slot="header"
            style="font-weight: bold"
          >结算数据</div>
          <div>
            <el-form>
              <el-table
                :data="tableData"
                style="width: 100%"
              >
                <el-table-column
                  label="账单日期"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <span>{{
                      emptyTrans(
                        scope.row[0].endTime
                          ? scope.row[0].startTime + ":" + scope.row[0].endTime
                          : scope.row[0].startTime + "至今"
                      )
                    }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="任务名称"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <span>{{ emptyTrans(scope.row[0].packageName) }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="单价/比例"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <div v-for="items in scope.row">
                      <span>{{ moneyTrans(items.outPrice) }}</span>
                    </div>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="数据/订单额"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <div v-for="items in scope.row">
                      <span v-if="items.billingType=='263'">{{moneyTrans(items.trafficUserApprovalDataNums)}}</span>
                      <span v-else>{{emptyTrans(items.trafficUserApprovalDataNums)}}</span>
                    </div>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="佣金(含税)"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <span>{{
                      moneyTrans(scope.row[0].trafficUserApprovalMoney)
                    }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="佣金"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <span>{{
                      moneyTrans(scope.row[0].actualSettlementExpenditure)
                    }}</span>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  label="税点"
                  label-width="100px"
                >
                  <el-form-item slot-scope="scope">
                    <span>{{ moneyTrans(scope.row[0].taxPoint) }}</span>
                  </el-form-item>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
          <div style="font-size: 14px; margin-top: 16px">
            <el-row>
              <el-col
                :span="12"
                class="see"
              >
                共计
                <span>{{ emptyTrans(tableTotal) }}</span>
                条
              </el-col>
              <el-col
                :span="12"
                style="text-align: right; float: right"
                min-width="350px"
              >
                <span class="see">合计:</span>:&nbsp;&nbsp;佣金(含税)总额:
                <span>{{ moneyTrans(commissionTotals) }}</span>
                &nbsp;&nbsp;佣金:
                <span>{{ moneyTrans(amountSettlement) }}</span>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </div>
    <template>
      <create-pdf
        ref="pdfmodel"
        @callback="handleCallBack"
        style="position: fixed; left: -10000px"
      />
    </template>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import {
  getBillDetail,
  getAduserInfo,
  applySettlement,
  getBillAppliedDetail,
  getBillDetailInfo,
} from "@/api/bill";
import {
  emptyTrans,
  formatMoney,
  formatDate,
  statusTrans,
  countCurrentPage,
  getDictList,
} from "@/api/dataTrans.js";
import CreatePdf from "../pdf/createPdfFile.vue";
export default {
  components: {
    NavBar,
    CreatePdf,
  },
  data () {
    return {
      tableData: [],
      tableTotal: null,
      billId: null,
      form: [],
      commissionTotals: null,
      amountSettlement: null,
      subjectList: [],
      otherInfo: [],
      showStatus: false,
    };
  },
  mounted () {
    this.billId = this.$route.query.id;
    this.showStatus = this.$route.query.showStatus;
    console.log(this.showStatus);
    this.entityList = getDictList(254);
    this.invoiceList = getDictList(212);
    this.getDetil();
    // this.getAduser();
  },
  methods: {
    back () {
      this.$router.push("/bill");
    },
    //生成对账单
    paymentReported () {
      const _this = this;
      getBillDetailInfo({ billId: this.billId }).then((res) => {
        if (res && res.code == "0") {
          _this.$refs.pdfmodel.initdata(res.data);
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    //生成PDF回调函数
    handleCallBack () {
      console.log("callback");
    },
    // 空字符转换
    emptyTrans (_val) {
      return emptyTrans(_val);
    },
    // 货币转换
    moneyTrans (_val) {
      return formatMoney(_val);
    },
    // 列表格式转换
    trans (_val, _list) {
      return statusTrans(_val, _list).val;
    },
    // 获取详情
    getDetil () {
      const _this = this;
      getBillDetail({ billId: this.billId }).then((res) => {
        if (res.code == 0) {
          _this.tableData = _this.transMediaData(
            res.data.jdTrafficIntervalDataVOList
          );
          _this.tableTotal = _this.tableData.length;
          _this.commissionTotals = res.data.amountApproval;
          _this.amountSettlement = res.data.amountSettlement;
        }
      });
    },
    // 区间数据转换
    transMediaData (_dataArr) {
      var _arr = _dataArr;
      let newData = {};
      _arr.forEach((e) => {
        //新建属性名
        e.intervalTag = e.intervalId + "_tag";
        if (Object.keys(newData).indexOf("" + e.intervalTag) === -1) {
          newData[e.intervalTag] = [];
        }
        newData[e.intervalTag].push(e);
      });
      var arrArr = [];
      Object.keys(newData).forEach((items) => {
        arrArr.push(newData[items]);
      });
      this.isArea = true;
      return arrArr;
    },
    // 获取账单数据
    getAduser () {
      const _this = this;
      getAduserInfo({ trafficId: this.billId }).then((res) => {
        if (res && res.code == 0) {
          _this.otherInfo = res.data.trafficSubjectVOS;
          res.data.trafficSubjectVOS.forEach((item) => {
            if (item.type == 1) {
              _this.subjectList.push(item);
            }
          });
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 区间id处理
    idTrans (_val) {
      var newId = "";
      _val.forEach((item) => {
        newId = item.userId + ",";
      });
      return newId;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-form-item__label {
  text-align: left;
}

/deep/.el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/.el-form-item {
  margin-bottom: 16px;
}

.icon {
  display: none;
  text-align: center;
}

/deep/.el-form-item__label {
  text-align: right;
}
.iconfont {
  display: none;
}
/deep/.el-form-item {
  width: 90%;
  margin-bottom: 22px;
}
.list-container {
  background-color: #fff;
  padding: 24px;
  margin-right: 24px;
  min-height: 860px;
}
.menu-title {
  height: 60px;
  line-height: 60px;
  width: 100%;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  padding-left: 24px;
  overflow: hidden;
  margin-bottom: 24px;
}
.space {
  text-align: right;
}
/deep/ .el-dialog__footer {
  border: none;
}
.see {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
}
</style>